// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"_1_eA2kgnkjYoPnP60Mvo86"};